module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Zurück","continue":"Weiter","submit":"Absenden"},"en":{"back":"Back","continue":"Continue","submit":"Submit"}}')
  delete Component.options._Ctor
}
